import classnames from 'classnames'
import RecipientAvatar from 'components/RecipientAvatar'
import useActiveAgentStatus from 'hooks/useActiveAgentStatus'
import { useRecipientResolution } from 'hooks/useRecipientResolution'
import { pathOr } from 'ramda'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { AgentStatus } from 'types/conversation'

import './style.css'
import './style.css'

interface PresenceAvatarProps {
  size?: string,
  id?: number,
  className?: string,
  image?: string
}


const PresenceAvatar = ({ size = 'LARGE', id = null, className, image }: PresenceAvatarProps) => {
  const { t } = useTranslation()
  const { recipient } = useRecipientResolution(id)
  const agentAvatar = useMemo(() => pathOr(null, ['avatarUrl'], recipient), [recipient])
  const isBotAvatar = useMemo(() => pathOr(false, ['bot'], recipient), [recipient])
  const status = useActiveAgentStatus(id, recipient.bot)

  const statusText = useMemo(() => {
    if (!status) {
      return null
    }

    if (status === AgentStatus.ONLINE) {
      return t('user.status.active')
    } else if (status === AgentStatus.OFFLINE) {
      return t('user.status.away')
    }

    return null
  }, [status, t])

  if (!agentAvatar && !isBotAvatar) {
    return null
  }

  return (
    <div className={classnames("drift-widget-presence-avatar", className)} title={status ? statusText : ''}>
      <RecipientAvatar size={size} id={id} image={image || agentAvatar} />
      { status && status === AgentStatus.ONLINE &&
        <div className={classnames('drift-widget-agent-status', 'drift-widget-agent-status--online')} aria-label={`agent status ${statusText}`}/>
      }
      { status && status === AgentStatus.OFFLINE &&
        <div className={classnames('drift-widget-agent-status', 'drift-widget-agent-status--offline')} aria-label={`agent status ${statusText}`}>
          <div className="drift-widget-agent-status--offline-dot"/>
        </div>
      }
    </div>
  )
}


export default PresenceAvatar
